export {
    SuiDimmerModule,
    SuiDimmer
} from "./index";
